import React from 'react';
import Images from '../../components/Images/Images';

export const ServiceCentersMap = ({ description, link, label_button, logo, map }) => {
  return (
    <div className="sc-block sc-map sc-padding">
      <div className="sc-map__image-content">
        <Images src={map.url} alt='Mapa de México' className="sc-map__image" />
      </div>
      <div className="sc-map__content">
        <Images src={logo.url} alt='Servicio Calorex Logo' className="sc-map__logo" />
        <div className="sc-map__description" dangerouslySetInnerHTML={{ __html: description.html }} />
        <a href={link.url} target={link.target} rel={`${link.target === '_blank' ? 'noopener noreferrer' : ''}`} className="sc-map__link o-link-semicircle">
          <div className={`o-link-semicircle-white`}></div>
          <p className={`o-link-semicircle_type_item`}>{label_button.text}</p>
        </a>
      </div>
    </div>
  )
};
